<template>
  <div class="chatbot-config">
    <div class="field">
      <label class="checkbox is-size-5">
        <input type="checkbox" v-model="config.enabled" />
        Chatbot enabled for <strong>{{ tenantName }}</strong>
      </label>
      <p class="help">When disabled, the extension skips onboarding and opens straight on Customise.</p>
    </div>

    <hr />
    <label class="label">Journey texts</label>
    <p v-if="!journeyKeys.length" class="help">No journey configured for this tenant yet.</p>

    <div v-for="key in journeyKeys" :key="key" class="field journey-field">
      <label class="label is-small">{{ humanize(key) }}</label>

      <template v-if="Array.isArray(config.journey[key])">
        <div v-for="(item, i) in config.journey[key]" :key="i" class="line">
          <textarea class="textarea is-small" rows="2" v-model="config.journey[key][i]"></textarea>
          <button class="button is-small is-danger is-light" @click="config.journey[key].splice(i, 1)" title="remove line">✕</button>
        </div>
        <button class="button is-small is-light add-line" @click="config.journey[key].push('')">+ add line</button>
      </template>

      <textarea v-else class="textarea is-small" rows="2" v-model="config.journey[key]"></textarea>
    </div>

    <hr />
    <div class="field">
      <button class="button is-success" :class="{ 'is-loading': saving }" @click="save" :disabled="!tenant.selected">
        Save chatbot config
      </button>
      <span v-if="savedMsg" class="tag is-success is-light saved-tag">{{ savedMsg }}</span>
    </div>
  </div>
</template>

<script>
import { getChatbotConfig, updateChatbotConfig } from "../../api/api"
import { tenantStore } from "../../tenant/tenant"

export default {
  name: 'ChatbotConfig',
  data() {
    return {
      tenant: tenantStore,
      config: { enabled: false, journey: {} },
      saving: false,
      savedMsg: '',
    }
  },
  computed: {
    tenantName() { return this.tenant.current ? this.tenant.current.name : '' },
    journeyKeys() { return this.config.journey ? Object.keys(this.config.journey) : [] },
  },
  watch: {
    'tenant.selected': {
      immediate: true,
      handler(code) { if (code) this.load() },
    },
  },
  methods: {
    humanize(k) { return String(k).replace(/[_-]+/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\b\w/g, c => c.toUpperCase()) },
    async load() {
      try {
        const resp = await getChatbotConfig()
        this.config = { enabled: !!resp.data.enabled, journey: resp.data.journey || {} }
      } catch (e) {
        this.config = { enabled: false, journey: {} }
      }
    },
    async save() {
      this.saving = true
      this.savedMsg = ''
      try {
        await updateChatbotConfig({ enabled: this.config.enabled, journey: this.config.journey })
        this.savedMsg = 'Saved'
        setTimeout(() => { this.savedMsg = '' }, 2500)
      } catch (e) {
        this.savedMsg = 'Save failed'
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.chatbot-config { max-width: 780px; }
.journey-field { margin-bottom: 0.9rem; }
.line { display: flex; gap: 0.4rem; margin-bottom: 0.35rem; }
.line .textarea { flex: 1; }
.add-line { margin-top: 0.2rem; }
.saved-tag { margin-left: 0.6rem; }
</style>
